import { useId, useSyncExternalStore } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";
import { sceneCalculationState, subscribeSceneCalculation } from "../../services/sceneCalculation";

/**
 * The application's lock while the layout's shading is calculated: one modal
 * over everything, with the progress and the only thing worth doing meanwhile,
 * stopping it. Nothing behind it can be clicked, the menu included, so nothing
 * leads away from a result that belongs to the layout on the page.
 */
export default function SceneCalculationOverlay() {
  const { isGreek } = useLanguage();
  const titleId = useId();
  const state = useSyncExternalStore(subscribeSceneCalculation, sceneCalculationState, sceneCalculationState);
  if (!state) return null;
  const tr = (el, en) => (isGreek ? el : en);
  const fraction = Math.max(0, Math.min(1, Number(state.progress) || 0));
  const percent = Math.round(fraction * 100);
  const face = state.faces > 1 ? Math.min(state.faces, Math.floor(fraction * state.faces) + 1) : null;
  return (
    <Dialog open disableEscapeKeyDown onClose={() => {}} maxWidth="xs" fullWidth aria-labelledby={titleId}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}>
      <DialogTitle id={titleId}>{tr("Υπολογισμός σκιάσεων", "Calculating shading")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" role="status" sx={{ mb: 1, fontVariantNumeric: "tabular-nums" }}>
          {face
            ? tr(`Πλευρά ${face} από ${state.faces} · ${percent}%`, `Face ${face} of ${state.faces} · ${percent}%`)
            : `${percent}%`}
        </Typography>
        <LinearProgress variant="determinate" value={percent}
          aria-label={tr("Πρόοδος υπολογισμού σκιάσεων", "Shading calculation progress")} />
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1.25 }}>
          {tr("Η εφαρμογή περιμένει να ολοκληρωθεί ο υπολογισμός, ώστε να μη χαθεί το αποτέλεσμά του.",
            "The application waits for the calculation to finish, so that its result is not lost.")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={state.cancel} sx={{ textTransform: "none" }}>{tr("Ακύρωση υπολογισμού", "Cancel calculation")}</Button>
      </DialogActions>
    </Dialog>
  );
}
